import React, { ReactElement } from 'react';
import { TerminDetail } from 'tezaury-frontend-ts-axios';
import { useNavigate } from 'react-router';
import DetailTerminuSectionHeading
  from '../DetailTerminuSectionHeading/DetailTerminuSectionHeading';
import DetailTerminuJudikatyARozdeleniaSudovSection
  from './DetailTerminuJudikatyARozdeleniaSudovSection';
import TerminDetailEmptyDataMessage
  from '../TerminDetailEmptyDataMessage/TerminDetailEmptyDataMessage';
import routes from '../../../routing/routes';

interface Props {
  termin: TerminDetail;
  admin?: boolean;
}

const DetailTerminuJudikatyARozdeleniaSudov = ({ termin, admin = false }: Props): ReactElement => {
  const navigate = useNavigate();
  const showJudikatyARozdeleniaSudov = (): boolean => termin && (termin.judikatSkList.length > 0
      || termin.judikatEuList.length > 0
      || termin.rozhodnutiaSkSudyList.length > 0
      || termin.rozhodnutiaEuSudyList.length > 0
      || termin.pravoEuList.length > 0
      || termin.euroVocList.length > 0);

  return (
    <>
      {(admin || showJudikatyARozdeleniaSudov()) && (
        <div className="detail-judikaty">
          <DetailTerminuSectionHeading
            heading="Judikáty a rozhodnutia súdov"
            admin={admin}
            onClick={() => navigate(routes.tezaurus.admin.termin.edit.zaznamySekcie
              .withParams(termin.tezaurus.uuid, termin.uuid))}
            terminListNotEmpty={showJudikatyARozdeleniaSudov()}
          />

          {admin && !showJudikatyARozdeleniaSudov() && (
          <TerminDetailEmptyDataMessage text="Termín nemá žiadne judikáty." />
          )}

          <DetailTerminuJudikatyARozdeleniaSudovSection
            list={termin.judikatSkList}
            header="Judikát SK"
          />
          <DetailTerminuJudikatyARozdeleniaSudovSection
            list={termin.judikatEuList}
            header="Judikát EÚ"
          />
          <DetailTerminuJudikatyARozdeleniaSudovSection
            list={termin.rozhodnutiaSkSudyList}
            header="Rozhodnutie súdu SK"
          />
          <DetailTerminuJudikatyARozdeleniaSudovSection
            list={termin.rozhodnutiaEuSudyList}
            header="Rozhodnutie súdu EÚ"
          />
          <DetailTerminuJudikatyARozdeleniaSudovSection
            list={termin.pravoEuList}
            header="Právo EÚ"
          />
          <DetailTerminuJudikatyARozdeleniaSudovSection
            list={termin.euroVocList}
            header="EuroVoc"
          />
        </div>
      )}
    </>
  );
};

export default DetailTerminuJudikatyARozdeleniaSudov;
